export default __webpack_public_path__ + "static/1843-881beedcb5426b9fe11cd54dbb4adf3f.gif";